export const DocumentActionTypes = {
    LOGOUT: 'LOGOUT',

    ADD_DOCUMENT_REQUEST: 'ADD_DOCUMENT_REQUEST',
    ADD_DOCUMENT_REQUEST_SUCCESS: 'ADD_DOCUMENT_REQUEST_SUCCESS',
    ADD_DOCUMENT_REQUEST_ERROR: 'ADD_DOCUMENT_REQUEST_ERROR',
    ADD_DOCUMENT_REQUEST_STATUS: 'ADD_DOCUMENT_REQUEST_STATUS',

    DOCUMENT_LIST_REQUEST: 'DOCUMENT_LIST_REQUEST',
    DOCUMENT_LIST_REQUEST_SUCCESS: 'DOCUMENT_LIST_REQUEST_SUCCESS',
    DOCUMENT_LIST_REQUEST_ERROR: 'DOCUMENT_LIST_REQUEST_ERROR',

    DOCUMENT_DETAIL_REQUEST: 'DOCUMENT_DETAIL_REQUEST',
    DOCUMENT_DETAIL_REQUEST_SUCCESS: 'DOCUMENT_DETAIL_REQUEST_SUCCESS',
    DOCUMENT_DETAIL_REQUEST_ERROR: 'DOCUMENT_DETAIL_REQUEST_ERROR'
}